import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { transparentize } from '@savgroup-front-common/primitive/helpers/cssColor';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';
import { rem } from '@savgroup-front-common/primitive/helpers/units';

export const $LoadingWrapper = styled.div<{
  $isSmall?: boolean;
  $isDisabled?: boolean;
}>`
  display: flex;
  width: 100%;
  border-radius: ${({ theme }) => theme.tw.radius.lg};
  border: 1px solid
    ${({ theme, $isDisabled }) =>
      $isDisabled ? theme.colors.secondaryColor2 : theme.colors.disabled};
  gap: ${spacing(3.5)};
  height: ${({ $isSmall }) => ($isSmall ? spacing(36) : 'auto')};
  align-items: ${({ $isSmall }) => ($isSmall ? 'center' : 'stretch')};
  background-color: ${({ theme, $isDisabled }) =>
    $isDisabled ? theme.colors.secondaryColor2 : 'transparent'};

  @media ${media.maxWidth.xs} {
    flex-direction: ${({ $isSmall }) => ($isSmall ? 'row' : 'column')};
    padding: ${spacing(3.5)};
    height: ${({ $isSmall }) => ($isSmall ? spacing(72) : 'auto')};
  }
`;

export const $HomePageProductItemWrapper = styled.div<{
  $isSmall?: boolean;
  $isDisabled?: boolean;
}>`
  display: flex;
  width: 100%;
  border-radius: ${({ theme }) => theme.tw.radius.lg};
  border: 1px solid
    ${({ theme, $isDisabled }) =>
      $isDisabled ? theme.colors.secondaryColor2 : theme.colors.disabled};
  padding: 0 ${spacing(3.5)};
  gap: ${spacing(3.5)};
  height: ${({ $isSmall }) => ($isSmall ? spacing(36) : 'auto')};
  align-items: ${({ $isSmall }) => ($isSmall ? 'center' : 'stretch')};
  background-color: ${({ theme, $isDisabled }) =>
    $isDisabled ? theme.colors.secondaryColor2 : 'transparent'};

  @media ${media.maxWidth.xs} {
    flex-direction: ${({ $isSmall }) => ($isSmall ? 'row' : 'column')};
    padding: ${spacing(3.5)};
    height: ${({ $isSmall }) => ($isSmall ? spacing(72) : 'auto')};
  }
`;

export const $ProductItemWrapper = styled.div`
  flex: 3;
  display: flex;
  gap: ${spacing(3.5)};
  align-items: center;
  height: auto;
  padding: ${spacing(9)} 0;

  @media ${media.maxWidth.xs} {
    width: 100%;
    padding: ${spacing(3.5)} 0;
  }
`;

export const $ProductItemAction = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 300px;

  @media ${media.maxWidth.xs} {
    flex: 1;
    width: 100%;
    border-top: 1px solid ${({ theme }) => theme.colors.disabled};
  }

  && > button {
    margin-top: ${spacing('sm')};
    margin-bottom: ${spacing('sm')};
    text-align: left;

    @media ${media.maxWidth.xs} {
      padding: 0;
    }

    &:hover,
    &:focus {
      background-color: ${({ theme }) =>
        transparentize(0.95, theme.colors.primary)};
    }

    & svg {
      fill: none;

      @media ${media.maxWidth.xs} {
        margin-right: ${spacing(3.5)};
      }
    }
  }
`;

export const $ChevronForMobile = styled.div`
  display: none;

  @media ${media.maxWidth.xs} {
    display: flex;

    &&&& svg {
      fill: ${({ theme }) => theme.colors.paragraphTextColor};
    }
  }
`;

export const $Separator = styled.div`
  width: 100%;
  height: 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.disabled};
`;

export const $ProductItemPictureWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.lightGrey};
  padding: ${spacing('xs')} ${spacing('sm')};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${({ theme }) => theme.tw.radius.sm};
  margin-right: ${spacing(3.5)};
  width: 70px;
  height: 70px;
  overflow: hidden;
`;

export const $CardContentThumbnail = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  && svg {
    max-width: ${spacing(9)};
    max-height: ${spacing(9)};
  }

  && img {
    object-fit: contain;
    max-height: ${rem(60)};
    max-width: ${rem(60)};
  }
`;

export const $ProductItemContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('sm')};
`;
export const $ProductItemTitle = styled.div`
  color: ${({ theme }) => theme.colors.darkBackground};
  ${fontStyle('lg')};
  font-weight: ${fontWeight('normal')};
`;
export const $ProductItemInfo = styled.div`
  display: flex;
  gap: ${spacing(7)};
`;
export const $ProductItemInfoLabel = styled.div`
  color: ${({ theme }) => theme.colors.paragraphTextColor};
  ${fontStyle('sm')};
  font-weight: ${fontWeight('normal')};
  line-height: calc(${({ theme }) => theme.tw.font.size.sm} + 2px);
`;
export const $ProductItemInfoDate = styled.div`
  color: ${({ theme }) => theme.colors.darkBackground};
  font-weight: ${fontWeight('bold')};
`;

export const $CardTagWrapperHeader = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  @media ${media.maxWidth.sm} {
    flex-direction: row;
  }
`;

export const $CardTagHeader = styled.div`
  margin-right: ${spacing('sm')};

  &:last-child {
    margin-right: 0;
  }
  @media ${media.maxWidth.sm} {
    margin-bottom: 0;
    margin-left: 0;
    margin-top: ${spacing('sm')};
  }
`;
